package pt.at.oss.kotlin.manual.storage.common.fixedestablishments

import kotlinx.serialization.Serializable
import pt.at.oss.kotlin.manual.storage.common.Address
import pt.at.oss.kotlin.manual.storage.common.VatId
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * FixedEstablishmentsEntry Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class FixedEstablishmentsEntry(
    var hasRealEstablishment: Boolean = false,
    var taxIdentif: VatId = VatId(),
    var tradingName: String = "",
    var address: Address = Address()
) : BaseRecord()
